import { PlayerContextState } from "../PlayerContext";

export enum EventTag {
  EARLY_GAME = "EARLY_GAME",
  INCONSEQUENTIAL_RANDOM_EVENT = "INCONSEQUENTIAL_RANDOM_EVENT",
  LEVEL_UP = "LEVEL_UP",
  LEVEL_UP_FIRST_FIFTEEN_MINS = "LEVEL_UP_FIRST_FIFTEEN_MINS",
  LEVEL_UP_EMPTY = "LEVEL_UP_EMPTY",
  STORYLINE = "STORYLINE",
  DO_NOT_AUTO_TRIGGER_IF_ONGOING = "DO_NOT_AUTO_TRIGGER_IF_ONGOING",
  DO_NOT_POPUP = "DO_NOT_POPUP",
}

export type EventTransform = (
  state: PlayerContextState,
  params: any,
) => PlayerContextState;

export interface EventMessageOption {
  description: string;
  isEnabled: boolean;
  transform?: (state: PlayerContextState, params: any) => PlayerContextState;
  nextMessage?: EventMessage;
}

export interface EventMessage {
  getId(): string;
  getTitle(params: any): string;
  getDescription(state: PlayerContextState, params: any): string;
  getAllowedOptions(
    state: PlayerContextState,
    params: any,
  ): EventMessageOption[];
  isTerminal(): boolean;
  isActionable(state: PlayerContextState, params: any): boolean;
}

export interface GameEvent {
  getId(): string;
  getMainEventMessage(): EventMessage;
  onTrigger(): EventTransform | undefined;
  getTags(): EventTag[];
}
